import React from "react";
import CreditCard from "./creditcard";
import { IoIosAddCircleOutline } from "react-icons/io";
import AddPlantCard from "./addplantCard";
import "./index.css";
import { Row, Col, Button, Card } from "antd";
import { BsChevronLeft } from "react-icons/bs";
import { BsChevronRight } from "react-icons/bs";
import "./index.css";
import LoaderGif from "../../assets/images/ie_loader.gif";
export default function CreditCardInfo({
  inputText,
  cardIcon,
  cards,
  isOpenCard,
  currentPage,
  previousPage,
  metaData,
  isLoading
}) {
  console.log('metaData-==>', metaData)
  return (
    <Row justify="center" style={{ padding: "2rem 0rem" }} gutter={[0, 10]}>
      <Col xs={24} sm={24} md={24} lg={24} xl={24}>
        <Card style={{ border: "1px solid #eee" }}>
          <h3 className="text-left st-cardheadingtext">
            Credit Card Information
          </h3>
          <Row justify="start" style={{ padding: "1rem", }} gutter={[10, 10]}>
            <Col xs={24} sm={24} md={12} lg={8} xl={8} className="custom">
              <AddPlantCard
                cardIcon={
                  <IoIosAddCircleOutline
                    size={60}
                    style={{ marginTop: "-30px" }}
                  />
                }
                cardText="Add new Card"
                className="ant-card-body"
                cardStyle={{
                  height: "171px",
                  boxShadow: "0px 0px 5px 0px rgb(0 0 0 / 16%)",
                  transition: "box-shadow .25s",
                }}
                onChangePlantModal={isOpenCard}
              />
            </Col>
            {!isLoading &&
              cards.map((item) => {
                return (
                  <Col xs={24} sm={24} md={12} lg={8} xl={8}>
                    <CreditCard
                      tickIcon={true}
                      dotsIcon={true}
                      data={item}
                      cardStyle={{
                        height: "171px",
                        boxShadow: "0px 0px 5px 0px rgb(0 0 0 / 16%)",
                        transition: "box-shadow .25s",
                      }}
                    />
                  </Col>
                )
              })
            }
            {isLoading &&
              <Row justify="end" align="middle" className="text-left">
                <Col className="text-left" xs={6} sm={6} md={10} lg={3} xl={3}>
                  <img src={LoaderGif} height={"40"} width={"40"} />
                </Col>
              </Row>
            }
          </Row>
          <Col xs={24} sm={24} md={23} lg={23} xl={23}>
            <Row
              gutter={[5, 0]}
              xs={24}
              sm={24}
              md={23}
              lg={23}
              xl={23}
              justify="start"
            >
              <Col className="tablePagination">
                {`Displaying ${metaData?.current_page !== metaData.total_pages
                  ? metaData?.current_records * metaData?.current_page
                  : metaData?.total_records
                  } of ${metaData?.total_records}`}
                <Button
                  type="link"
                  icon={<BsChevronLeft color="#686868" size={15} />}
                  onClick={previousPage}
                  disabled={metaData?.current_page === 1}
                />
                <Button
                  type="link"
                  icon={<BsChevronRight color="#686868" size={15} />}
                  onClick={currentPage}
                  disabled={metaData?.total_pages === metaData?.current_page}
                />
              </Col>
            </Row>
          </Col>
        </Card>
      </Col>
    </Row>
  );
}
